export default __webpack_public_path__ + "static/Login-banner-1x-877d7dc66f98cd18d8927eaccdc56270.png";